import { Icon, useStyleConfig } from '@chakra-ui/react';
import React from 'react';

import { WLIconProps } from '../icon.props.interface';

const RetireeIcon: React.FC<WLIconProps> = ({ variant, ...rest }) => {
  const styles = useStyleConfig('Icon', { variant });

  return (
    <Icon viewBox="0 0 600 600" {...rest} __css={styles}>
      <desc id="svgdescPersonaRetiree">Sun</desc>
      <circle className="background" cx="301.4" cy="299" r="296.8" />
      <path
        className="accent"
        d="M493.6 339c-21.1-21.8-21.2-56.4-.2-78.3l33.3-34.8-47.4-8.3c-29.9-5.2-50.3-33.1-46.1-63.2l6.5-47.7-43.2 21.3c-27.2 13.3-60.2 2.7-74.5-24l-22.7-42.4-22.5 42.5c-14.2 26.8-47.1 37.6-74.4 24.4l-43.4-21 6.8 47.7c4.3 30-15.9 58-45.8 63.4l-47.4 8.5 33.5 34.6c21.1 21.8 21.2 56.4.2 78.2L73 374.7l47.4 8.3c29.9 5.2 50.3 33.1 46.2 63.2l-6.6 47.7 43.2-21.2c27.2-13.3 60.1-2.7 74.5 24l22.8 42.4 22.5-42.5c14.2-26.8 47-37.6 74.4-24.4l43.3 20.9-6.8-47.6c-4.3-30 16-58 45.8-63.4l47.4-8.5-33.5-34.6zm-192.2 99.2c-76.9 0-139.2-62.3-139.2-139.3s62.3-139.3 139.2-139.3S440.7 222 440.7 299c-.1 76.9-62.4 139.2-139.3 139.2z"
      />
      <circle className="accent" cx="301.4" cy="299" r="125.4" />
    </Icon>
  );
};

export default RetireeIcon;
